import React from 'react';
import { Button, ButtonType } from '@redreamerlab/uikit';
import { Row } from '@styles/common';
import { StyledMessage, StyledModal, StyledTitle } from './Styles';

type Props = {
  title: string;
  opened: boolean;
  onClose: () => void;
  message: string;
};

const SuccessModal = ({ title, opened, onClose, message }: Props) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <StyledModal hasBackDrop opened={opened} onClose={handleClose} width="450" disabledCloseButton>
      <Row justify="space-between" align="center">
        <div>
          <StyledTitle>{title}</StyledTitle>
          {message && <StyledMessage dangerouslySetInnerHTML={{ __html: message }} />}
        </div>
      </Row>
      <Row justify="center">
        <Button
          buttonType={ButtonType.CUSTOM}
          btnColor="#ffffff"
          borderColor="#4C89FF"
          background="#4C89FF"
          width="87px"
          onClick={handleClose}
          mt="32px"
        >
          OK
        </Button>
      </Row>
    </StyledModal>
  );
};

export default SuccessModal;
